import { motion } from "framer-motion";
import ServiceIcon from "./ServiceIcon";
import { SERVICES, SERVICES_SECTION } from "../data/siteContent";

function ServiceCard({ service, index }) {
  const desc = service.desc || SERVICES_SECTION.defaultDesc;

  return (
    <motion.article
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ delay: (index % 6) * 0.06, duration: 0.55 }}
      whileHover={{ y: -10, transition: { duration: 0.3 } }}
      className="group relative flex min-h-[260px] flex-col overflow-hidden rounded-2xl border border-white/10 bg-slate-900/45 shadow-lg shadow-black/20 backdrop-blur-md transition-[border-color,box-shadow] duration-300 hover:border-cyan-400/40 hover:shadow-[0_20px_50px_-12px_rgba(34,211,238,0.25)] lg:min-h-[280px]"
    >
      {service.image && (
        <>
          <img
            src={service.image}
            alt=""
            className="absolute inset-0 h-full w-full object-cover opacity-0 scale-110 transition-all duration-500 ease-out group-hover:opacity-100 group-hover:scale-100"
            aria-hidden
          />
          <div
            className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100 bg-[linear-gradient(to_top,rgba(2,6,23,0.55)_0%,rgba(2,6,23,0.35)_30%,rgba(15,23,42,0.18)_55%,rgba(15,23,42,0.06)_80%,transparent_100%)]"
            aria-hidden
          />
        </>
      )}

      <div className="relative z-10 flex flex-1 flex-col items-center justify-center p-8 text-center">
        <ServiceIcon
          name={service.icon}
          size="large"
          className="!text-white transition-colors duration-300 group-hover:!text-cyan-300"
        />
        <h3 className="mt-8 font-sans text-xl font-bold text-white transition-colors duration-300 group-hover:text-cyan-50">
          {service.title}
        </h3>
        <p className="mt-4 max-w-[280px] flex-1 font-sans text-sm leading-relaxed text-white/55 transition-colors duration-300 group-hover:text-white/75">
          {desc}
        </p>
      </div>
    </motion.article>
  );
}

export default function Services() {
  const { eyebrow, title, background } = SERVICES_SECTION;

  return (
    <section id="services" className="relative overflow-hidden py-20 sm:py-28">
      <div className="absolute inset-0">
        <img
          src={background}
          alt=""
          className="h-full w-full scale-105 object-cover blur-[6px]"
          aria-hidden
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(2,6,23,0.92) 0%, rgba(15,23,42,0.88) 50%, rgba(2,6,23,0.94) 100%)",
          }}
        />
        <div className="absolute inset-0 bg-blue-950/30" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.header
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mx-auto max-w-3xl text-center"
        >
          <div className="mb-5 flex items-center justify-center gap-2">
            <span className="flex h-5 w-5 items-center justify-center rounded-md bg-gradient-to-br from-cyan-400 to-blue-600">
              <svg className="h-3 w-3 text-white" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
                <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z" />
              </svg>
            </span>
            <span className="font-sans text-sm font-medium text-cyan-300/90">{eyebrow}</span>
          </div>
          <h2 className="font-sans text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
            {title}
          </h2>
        </motion.header>

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6">
          {SERVICES.map((service, index) => (
            <ServiceCard key={service.title} service={service} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
